import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '../common'

import { useRestartTileStyles } from './styles'
import { useI18n } from '~/core/i18n'

const ApplyChangesTile = ({ onApplyChanges, onRestart, disabled, isRestartAllowed, isReloadAllowed, ...props }) => {
  const [msg] = useI18n()
  const classes = useRestartTileStyles()

  return (
    <article className={classes.restartTileWrapper} {...props}>
      <div className={classes.restartTileRow}>
        <Button
          disabled={disabled || !isReloadAllowed}
          id="apply-changes-btn"
          xStyle={disabled ? 'secondary' : 'danger'}
          onClick={onApplyChanges}
        >
          {msg('system.applychanges.content.reloadTitle')}
        </Button>
        <span>{msg('system.applychanges.content.reloadDescription')}</span>
      </div>
      <div className={classes.restartTileRow}>
        <Button
          disabled={disabled || !isRestartAllowed}
          id="restart-pbx-btn"
          xStyle={disabled ? 'secondary' : 'danger'}
          onClick={onRestart}
        >
          {msg('system.applychanges.content.restartTitle')}
        </Button>
        <span>{msg('system.applychanges.content.restartDescription')}</span>
      </div>
    </article>
  )
}

ApplyChangesTile.propTypes = {
  disabled: PropTypes.bool,
  isReloadAllowed: PropTypes.bool,
  isRestartAllowed: PropTypes.bool,
  onApplyChanges: PropTypes.func.isRequired,
  onRestart: PropTypes.func.isRequired
}

ApplyChangesTile.defaultProps = {
  onApplyChanges: void 0,
  onRestart: void 0
}

export default ApplyChangesTile
